<template functional>
    <button :class="[data.staticClass, data.class, {'loading-btn': props.loading}]"
            class="btn"
            :id="props.id"
            style="white-space: nowrap"
            :disabled="props.disabled || props.loading"
            :readonly="props.readonly"
            v-on:click="listeners.click && listeners.click()">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'Btn',
};

</script>
